import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { appSettings } from '../appSettings';

@Component({
  selector: 'app-metric-list',
  templateUrl: './metric-list.component.html',
  styleUrls: ['./metric-list.component.css']
})
export class MetricListComponent implements OnInit {

  constructor(private apiService: ApiService, private messageService: ToastrService) {
  }
  public params: any;
  public parent: any;
  public data: any;
  public loading: boolean;
  public visible: boolean = true;
  ngOnInit(): void {
  }

  public load(data) {
    this.loading = true;
     var idList;
    if (this.parent.parent.formIndex == 1)
      idList = [{ key: 'ScanId', value: data }];
    else idList = [{ key: 'ScanInstanceId', value: data }];
    this.apiService.post('/api/metrics', { idList: idList },null,appSettings.ovmApiServiceAddress)
      .subscribe(o => {

        this.data = o;
        if (this.data) {
          this.data.forEach(o => {
            var newName = o.name;
            var color = '';
            switch (o.name) {
              case 'assetCount':
                newName = 'alive assets encountered';
                color = "rgb(28, 139, 194)";
                break;
              case 'assetCountSeriousVulnerabilities':
                newName = 'assets affected by <span title="Serious vulnerabilities include Critical and High severity ratings."><u>serious</u></span> vulnerabilities';
                color = "rgb(186, 104, 200)";
                break;
              case 'newCriticalVulnerabilityCount':
                newName = 'new critical<br/> severity vulnerabilities';
                color = "rgb(128, 4, 2)";
                break;
              case 'newHighVulnerabilityCount':
                newName = 'new high<br/> severity vulnerabilities';
                color = "rgb(253, 1, 0)";
                break;
            }
            o.name = newName;
            o.color = color;
          })
        }
        this.loading = false;
      }, err => {
        this.loading = false;
        this.messageService.error('Could not load Metrics', 'Action');
      })
  }
}
